// import React from 'react'
// import { KTIcon, toAbsoluteUrl } from '../../../helpers'

// type Props = {
//     className: string
//     children?: React.ReactNode
// }

// const TablesWidget18: React.FC<Props> = ({ className }) => {
//     return (
//         <div className={`card ${className}`}>
//             {/* begin::Header */}
//             <div className='card-header border-0 pt-5'>
//                 <h3 className='card-title align-items-start flex-column'>
//                     <span className='card-label fw-bold fs-3 mb-1'>Collection Point Activity</span>
//                     <span className='text-dark mt-1 fw-semibold fs-7'>Over 500 members</span>
//                 </h3>
//             </div>
//             {/* end::Header */}
//             {/* begin::Body */}
//             <div className='card-body py-3'>
//                 {/* begin::Table container */}
//                 <div className='table-responsive'>
//                     {/* begin::Table */}
//                     <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
//                         {/* begin::Table head */}
//                         <thead>
//                             <tr className='fw-bold text-dark'>
//                                 <th className='min-w-200px'>Collection Point</th>
//                                 <th className='min-w-100px'>Status</th>
//                                 <th className='min-w-100px'>Household</th>
//                                 <th className='min-w-140px'>Volume</th>
//                                 <th className='min-w-120px'>Avg Collection</th>
//                                 <th className='min-w-120px'>Engagement</th>
//                             </tr>
//                         </thead>
//                         {/* end::Table head */}
//                         {/* begin::Table body */}
//                         <tbody>
//                             <tr>
//                                 <td>
//                                     <div className='d-flex align-items-center'>
//                                         <div className='symbol symbol-45px me-5'>
//                                             <img src={toAbsoluteUrl('/media/avatars/300-14.jpg')} alt='' />
//                                         </div>
//                                         <div className='d-flex justify-content-start flex-column'>
//                                             <a href='#' className='text-dark fw-bold text-hover-primary fs-6'>
//                                                 Ana Simmons
//                                             </a>
//                                             <span className='text-dark fw-semibold text-dark d-block fs-7'>
//                                                 HTML, JS, ReactJS
//                                             </span>
//                                         </div>
//                                     </div>
//                                 </td>
//                                 <td>
//                                     <span className='badge badge-light-success fw-bold'>Active</span>
//                                 </td>
//                                 <td>
//                                     <span className='text-dark fw-bold fs-6'>25</span>
//                                 </td>
//                                 <td>
//                                     <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
//                                         150 kg
//                                     </a>
//                                     <span className='text-dark fw-semibold d-block fs-7'>
//                                         Collected
//                                     </span>
//                                 </td>
//                                 <td>
//                                     <span className='text-dark fw-bold fs-6'>6 kg</span>
//                                 </td>
//                                 <td className='text-end'>
//                                     <div className='d-flex flex-column w-100 me-2'>
//                                         <div className='d-flex flex-stack mb-2'>
//                                             <span className='text-dark me-2 fs-7 fw-semibold'>50%</span>
//                                         </div>
//                                         <div className='progress h-6px w-100'>
//                                             <div
//                                                 className='progress-bar bg-primary'
//                                                 role='progressbar'
//                                                 style={{ width: '50%' }}
//                                             ></div>
//                                         </div>
//                                     </div>
//                                 </td>
//                             </tr>
//                             <tr>
//                                 <td>
//                                     <div className='d-flex align-items-center'>
//                                         <div className='symbol symbol-45px me-5'>
//                                             <img src={toAbsoluteUrl('/media/avatars/300-2.jpg')} alt='' />
//                                         </div>
//                                         <div className='d-flex justify-content-start flex-column'>
//                                             <a href='#' className='text-dark fw-bold text-hover-primary fs-6'>
//                                                 Jessie Clarcson
//                                             </a>
//                                             <span className='text-dark fw-semibold text-dark d-block fs-7'>
//                                                 C#, ASP.NET, MS SQL
//                                             </span>
//                                         </div>
//                                     </div>
//                                 </td>
//                                 <td>
//                                     <span className='badge badge-light-warning fw-bold'>Pending</span>
//                                 </td>
//                                 <td>
//                                     <span className='text-dark fw-bold fs-6'>18</span>
//                                 </td>
//                                 <td>
//                                     <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
//                                         230 kg
//                                     </a>
//                                     <span className='text-dark fw-semibold d-block fs-7'>
//                                         Collected
//                                     </span>
//                                 </td>
//                                 <td>
//                                     <span className='text-dark fw-bold fs-6'>12.7 kg</span>
//                                 </td>
//                                 <td className='text-end'>
//                                     <div className='d-flex flex-column w-100 me-2'>
//                                         <div className='d-flex flex-stack mb-2'>
//                                             <span className='text-dark me-2 fs-7 fw-semibold'>70%</span>
//                                         </div>
//                                         <div className='progress h-6px w-100'>
//                                             <div
//                                                 className='progress-bar bg-danger'
//                                                 role='progressbar'
//                                                 style={{ width: '70%' }}
//                                             ></div>
//                                         </div>
//                                     </div>
//                                 </td>
//                             </tr>
//                             <tr>
//                                 <td>
//                                     <div className='d-flex align-items-center'>
//                                         <div className='symbol symbol-45px me-5'>
//                                             <img src={toAbsoluteUrl('/media/avatars/300-5.jpg')} alt='' />
//                                         </div>
//                                         <div className='d-flex justify-content-start flex-column'>
//                                             <a href='#' className='text-dark fw-bold text-hover-primary fs-6'>
//                                                 Robert Doe
//                                             </a>
//                                             <span className='text-dark fw-semibold text-dark d-block fs-7'>
//                                                 Web Developer
//                                             </span>
//                                         </div>
//                                     </div>
//                                 </td>
//                                 <td>
//                                     <span className='badge badge-light-success fw-bold'>Active</span>
//                                 </td>
//                                 <td>
//                                     <span className='text-dark fw-bold fs-6'>32</span>
//                                 </td>
//                                 <td>
//                                     <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
//                                         180 kg
//                                     </a>
//                                     <span className='text-dark fw-semibold d-block fs-7'>
//                                         Collected
//                                     </span>
//                                 </td>
//                                 <td>
//                                     <span className='text-dark fw-bold fs-6'>5.6 kg</span>
//                                 </td>
//                                 <td className='text-end'>
//                                     <div className='d-flex flex-column w-100 me-2'>
//                                         <div className='d-flex flex-stack mb-2'>
//                                             <span className='text-dark me-2 fs-7 fw-semibold'>60%</span>
//                                         </div>
//                                         <div className='progress h-6px w-100'>
//                                             <div
//                                                 className='progress-bar bg-success'
//                                                 role='progressbar'
//                                                 style={{ width: '60%' }}
//                                             ></div>
//                                         </div>
//                                     </div>
//                                 </td>
//                             </tr>
//                             <tr>
//                                 <td>
//                                     <div className='d-flex align-items-center'>
//                                         <div className='symbol symbol-45px me-5'>
//                                             <img src={toAbsoluteUrl('/media/avatars/300-20.jpg')} alt='' />
//                                         </div>
//                                         <div className='d-flex justify-content-start flex-column'>
//                                             <a href='#' className='text-dark fw-bold text-hover-primary fs-6'>
//                                                 Natali Goodwin
//                                             </a>
//                                             <span className='text-dark fw-semibold text-dark d-block fs-7'>
//                                                 Python, PostgreSQL, ReactJS
//                                             </span>
//                                         </div>
//                                     </div>
//                                 </td>
//                                 <td>
//                                     <span className='badge badge-light-danger fw-bold'>Inactive</span>
//                                 </td>
//                                 <td>
//                                     <span className='text-dark fw-bold fs-6'>12</span>
//                                 </td>
//                                 <td>
//                                     <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
//                                         95 kg
//                                     </a>
//                                     <span className='text-dark fw-semibold d-block fs-7'>
//                                         Collected
//                                     </span>
//                                 </td>
//                                 <td>
//                                     <span className='text-dark fw-bold fs-6'>7.9 kg</span>
//                                 </td>
//                                 <td className='text-end'>
//                                     <div className='d-flex flex-column w-100 me-2'>
//                                         <div className='d-flex flex-stack mb-2'>
//                                             <span className='text-dark me-2 fs-7 fw-semibold'>50%</span>
//                                         </div>
//                                         <div className='progress h-6px w-100'>
//                                             <div
//                                                 className='progress-bar bg-warning'
//                                                 role='progressbar'
//                                                 style={{ width: '50%' }}
//                                             ></div>
//                                         </div>
//                                     </div>
//                                 </td>
//                             </tr>
//                             <tr>
//                                 <td>
//                                     <div className='d-flex align-items-center'>
//                                         <div className='symbol symbol-45px me-5'>
//                                             <img src={toAbsoluteUrl('/media/avatars/300-23.jpg')} alt='' />
//                                         </div>
//                                         <div className='d-flex justify-content-start flex-column'>
//                                             <a href='#' className='text-dark fw-bold text-hover-primary fs-6'>
//                                                 Kevin Leonard
//                                             </a>
//                                             <span className='text-dark fw-semibold text-dark d-block fs-7'>
//                                                 HTML, JS, ReactJS
//                                             </span>
//                                         </div>
//                                     </div>
//                                 </td>
//                                 <td>
//                                     <span className='badge badge-light-success fw-bold'>Active</span>
//                                 </td>
//                                 <td>
//                                     <span className='text-dark fw-bold fs-6'>45</span>
//                                 </td>
//                                 <td>
//                                     <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
//                                         320 kg
//                                     </a>
//                                     <span className='text-dark fw-semibold d-block fs-7'>
//                                         Collected
//                                     </span>
//                                 </td>
//                                 <td>
//                                     <span className='text-dark fw-bold fs-6'>7.1 kg</span>
//                                 </td>
//                                 <td className='text-end'>
//                                     <div className='d-flex flex-column w-100 me-2'>
//                                         <div className='d-flex flex-stack mb-2'>
//                                             <span className='text-dark me-2 fs-7 fw-semibold'>90%</span>
//                                         </div>
//                                         <div className='progress h-6px w-100'>
//                                             <div
//                                                 className='progress-bar bg-info'
//                                                 role='progressbar'
//                                                 style={{ width: '90%' }}
//                                             ></div>
//                                         </div>
//                                     </div>
//                                 </td>
//                             </tr>
//                         </tbody>
//                         {/* end::Table body */}
//                     </table>
//                     {/* end::Table */}
//                 </div>
//                 {/* end::Table container */}
//             </div>
//             {/* begin::Body */}
//         </div>
//     )
// }

// export { TablesWidget18 }



import React from 'react'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'

type Props = {
    className: string
    data?: any
}

const TablesWidget18: React.FC<Props> = ({ className, data }) => {
    const pickupPoints = data?.pickupPoints || []

    return (
        <div className={`card ${className}`}>
            {/* begin::Header */}
            <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-3 mb-1'>Material Hub activity</span>
                    <span className='text-dark mt-1 fw-semibold fs-7'>
                        {pickupPoints.length} Material Hubs
                    </span>
                </h3>
            </div>
            {/* end::Header */}
            {/* begin::Body */}
            <div className='card-body py-3'>
                {/* begin::Table container */}
                <div className='table-responsive'>
                    {/* begin::Table */}
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        {/* begin::Table head */}
                        <thead>
                            <tr className='fw-bold text-dark'>
                                <th className='min-w-200px'>Material Hub</th>
                                <th className='min-w-100px'>Status</th>
                                <th className='min-w-100px'>Household</th>
                                <th className='min-w-140px'>Volume</th>
                                <th className='min-w-120px'>Avg collection</th>
                                <th className='min-w-120px'>Engagement</th>
                            </tr>
                        </thead>
                        {/* end::Table head */}
                        {/* begin::Table body */}
                        <tbody>
                            {pickupPoints.map((point: any) => (
                                <tr key={point.id}>
                                    <td>
                                        <div className='d-flex align-items-center'>
                                            <div className='symbol symbol-45px me-5'>
                                                <div className='symbol-label bg-light-primary text-primary fs-6 fw-bold'>
                                                    {point.name.substring(0, 2).toUpperCase()}
                                                </div>
                                            </div>
                                            <div className='d-flex justify-content-start flex-column'>
                                                <a href='#' className='text-dark fw-bold text-hover-primary fs-6'>
                                                    {point.name}
                                                </a>
                                                <span className='text-dark fw-semibold text-dark d-block fs-7'>
                                                    Lat: {point.latitude}, Long: {point.longitude}
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <span
                                            className={point.active ? 'badge badge-light-success fw-bold' : 'badge fw-bold'}
                                            style={!point.active ? { backgroundColor: '#fff8dd', color: '#fbd124' } : undefined}
                                        >
                                            {point.active ? 'ACTIVE' : 'INACTIVE'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className='text-dark fw-bold fs-6'>{point.linkedCustomerCount}</span>
                                    </td>
                                    <td>
                                        <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                            {point.lifeTimePerformance?.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} kg
                                        </a>
                                        <span className='text-dark fw-semibold d-block fs-7'>
                                            Collected
                                        </span>
                                    </td>
                                    <td>
                                        <span className='text-dark fw-bold fs-6'>
                                            {point.linkedCustomerCount > 0
                                                ? (point.lifeTimePerformance / point.linkedCustomerCount)?.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                : '0'} kg
                                        </span>
                                    </td>
                                    <td className='text-end'>
                                        {/* <div className='d-flex flex-column w-100 me-2'>
                                            <div className='d-flex flex-stack mb-2'>
                                                <span className='text-dark me-2 fs-7 fw-semibold'>
                                                    {(point.participationRate * 100).toFixed(0)}%
                                                </span>
                                            </div>
                                            <div className='progress h-6px w-100'>
                                                <div
                                                    className='progress-bar bg-primary'
                                                    role='progressbar'
                                                    style={{ width: `${point.participationRate * 100}%` }}
                                                ></div>
                                            </div>
                                        </div> */}

                                        <div className='d-flex flex-column w-100 me-2'>
                                            <div className='d-flex flex-stack mb-2'>
                                                {/* <span className='text-dark me-2 fs-7 fw-semibold'>
      {(point.participationRate * 100).toFixed(0)}%
    </span>
  </div>
   <div className='d-flex flex-stack mb-2'> */}
                                                {point?.participationRate && +point?.participationRate > 0.75 ? (
                                                    <span className='badge badge-light-success text-success fw-bold fs-7'>{(point?.participationRate * 100).toFixed(2)}%</span>
                                                ) : point?.participationRate && +point?.participationRate >= 0.50 ? (
                                                    <span className='badge badge-light-warning text-warning fw-bold fs-7'>{(point?.participationRate * 100).toFixed(2)}%</span>
                                                ) : (
                                                    <span className='badge badge-light-danger text-danger fw-bold fs-7'>{(point?.participationRate * 100).toFixed(2)}%</span>
                                                )}
                                            </div>
                                            <div className='progress h-6px w-100' style={{ backgroundColor: '#4f45f533' }}>
                                                <div
                                                    className='progress-bar'
                                                    role='progressbar'
                                                    style={{ width: `${point.participationRate * 100}%`, backgroundColor: '#4f45f5' }}
                                                ></div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        {/* end::Table body */}
                    </table>
                    {/* end::Table */}
                </div>
                {/* end::Table container */}
            </div>
            {/* begin::Body */}
        </div>
    )
}

export { TablesWidget18 }